import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { di } from 'react-magnetic-di';
import Checkbox from '@atlaskit/checkbox';
import { CheckboxField } from '@atlaskit/form';
var BooleanInputPrompt = function BooleanInputPrompt(_ref) {
  var userInputPrompt = _ref.userInputPrompt;
  var variableName = userInputPrompt.variableName,
    displayName = userInputPrompt.displayName,
    defaultValue = userInputPrompt.defaultValue;
  return /*#__PURE__*/React.createElement(CheckboxField, {
    name: variableName,
    defaultIsChecked: defaultValue || false
  }, function (_ref2) {
    var fieldProps = _ref2.fieldProps;
    return /*#__PURE__*/React.createElement(Checkbox, _extends({}, fieldProps, {
      label: displayName
    }));
  });
};
export default BooleanInputPrompt;